import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import {
  DESCRIPTION,
  DOM_LIFE_YEARS,
  DOM_SENSITIVE,
  EUROPEAN_COMMERCE_CONTROL_NUMBER,
  HEIGHT,
  LENGTH,
  MLP,
  PART_NUMBER,
  PURCHASED_AT,
  SPECIAL_CONTAINER_FEE,
  SPECIAL_CONTAINER_REQ,
  TOTAL_CYCLES,
  TOTAL_HOURS,
  UNITED_NATIONS_CODE,
  WEIGHT,
  WIDTH,
  HTSUS_CODE,
  SCHEDULE_B_OR_HT_CODE
} from "MODULES/parts/constants";

export default function validate(values) {
  return validator(values, v => {
    v
      .validate(MLP, PURCHASED_AT)
      .satisfies(rules.requiredIfAnyDefined(MLP, PURCHASED_AT));

    v
      .validate(SPECIAL_CONTAINER_FEE)
      .satisfies(rules.requiredIfAnyDefined(SPECIAL_CONTAINER_REQ));

    v.validate(PART_NUMBER, DESCRIPTION).satisfies(rules.required);
    v.validate(WEIGHT, MLP).satisfies(rules.isNumeric, rules.isGreaterThan(0));
    v
      .validate(UNITED_NATIONS_CODE)
      .satisfies(rules.isInteger, rules.lengthIsEqual(4));

    if (
      !["EAR99", "SNCHK"].includes(values[EUROPEAN_COMMERCE_CONTROL_NUMBER])
    ) {
      v
        .validate(EUROPEAN_COMMERCE_CONTROL_NUMBER)
        .satisfies(
          rules.matchesPattern(
            /^[0-9][A-Za-z]\d{3}\.?[a-z]?\.?[0-9]?\.?[a-z]?$/
          )
        );
    }
    v
      .validate(LENGTH, WIDTH, HEIGHT)
      .satisfies(
        rules.requiredIfAnyDefined(LENGTH, WIDTH, HEIGHT),
        rules.isInteger,
        rules.isGreaterThan(0)
      );

    v
      .validate(TOTAL_HOURS)
      .satisfies(
        rules.requiredIfAnyDefined(TOTAL_HOURS),
        rules.isInteger,
        rules.isBetween(0, 999999)
      );

    v
      .validate(TOTAL_CYCLES)
      .satisfies(
        rules.requiredIfAnyDefined(TOTAL_CYCLES),
        rules.isInteger,
        rules.isBetween(0, 999999)
      );

    v
      .validate(DOM_LIFE_YEARS)
      .satisfies(rules.requiredIfAnyDefined(DOM_SENSITIVE), rules.isInteger);

    v
      .validate(HTSUS_CODE)
      .satisfies(
        rules.matchesPattern(
          /^([0-9][A-Z]{1})|([0-9]{4}(.)[0-9]{1,2}(.)[0-9]{0,4})$/
        )
      );

    v
      .validate(SCHEDULE_B_OR_HT_CODE)
      .satisfies(
        rules.matchesPattern(/(^[0-9]{4}(.)[0-9]{1,2}(.)[0-9]{0,4})$/)
      );
  });
}



// WEBPACK FOOTER //
// ./app/modules/parts/components/EditPart/validate.js